import React from 'react';
type TrustStripProps = {
  className?: string;
};
const ITEMS = ['📄 100% PDF', '⚡ Access in 5 min', '🛡️ 7-Day Guarantee', '🔒 Secure Payment'];
export function TrustStrip({
  className = ''
}: TrustStripProps) {
  return <ul className={`flex flex-wrap items-center justify-center gap-2 text-[11px] font-medium sm:text-xs ${className}`} data-id="element-165" data-mp="2jbjc06nvck0d">
      {ITEMS.map(item => <li key={item} className="rounded-full border border-white/10 bg-white/5 px-3.5 py-1.5 text-lilac-200" data-id="element-166" data-mp="2acxmfrjzc4q3">
          {item}
        </li>)}
    </ul>;
}